import ReactGA from "react-ga4";

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;

export const initGA = () => {
    if (MEASUREMENT_ID) {
        ReactGA.initialize(MEASUREMENT_ID);
    } else {
        console.warn("Google Analytics Measurement ID is missing.");
    }
};

export const trackPageView = (path: string) => {
    if (!MEASUREMENT_ID) return;
    ReactGA.send({ hitType: "pageview", page: path });
};

export const trackEvent = (
    category: string,
    action: string,
    label?: string,
    value?: number
) => {
    if (!MEASUREMENT_ID) return;
    ReactGA.event({
        category,
        action,
        label,
        value,
    });
};


export const trackSearch = (searchTerm: string) => {
    trackEvent("Search", "Search Term", searchTerm);
};

export const trackDosarSearch = (dosarNumber: string) => {
    trackEvent("Search", "Search Dosar", dosarNumber);
};

export const trackViewCase = (caseTitle: string) => {
    trackEvent("Content", "View Case", caseTitle);
};

export const trackSubscribeClick = (planName: string, price: number) => {
    trackEvent("Ecommerce", "Begin Checkout", planName, price);
};

export const trackLoginSuccess = () => {
    trackEvent("Auth", "Login Success");
};

export const trackContactFormSubmit = (subject: string) => {
    trackEvent("Lead", "Contact Form Submit", subject);
};
